/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect, useMemo } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";

import Footer from "../../examples/Footer";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import useSWR from "swr";
import { allImages } from "../../utils/contants";
import { FaCircleStop } from "react-icons/fa6";
import { FaCirclePlay } from "react-icons/fa6";
import OrderDetails from "../../components/OrderDetails";
import Rating from "@mui/material/Rating";
import arrowimg from "../../assets/images/arrowimg.png";
import ModalComponent from "components/ModalComponent";
import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReviewsIcon from "@mui/icons-material/Reviews";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import LoaderComponent from "components/Loader";
import { baseURL } from "utils/api";
import axios from "axios";
import TabComponent from "components/TabComponent";
import Select from "react-select";
import { TiTick } from "react-icons/ti";
import "./Order.css";

import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import OrderTrackingLocationUI from "components/OrderLocationTrackingUI";
function OrderList() {
  const navigate = useNavigate();
  // fetch data swr
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [file, setFile] = useState("");
  // useEffect(() => {
  //   async function fetchData() {
  //     setLoading(true);
  //     const { data } = await axios.get(`${baseURL}/admin/fetch-categories`);
  //     setLoading(false);

  //     setData(data?.categories);
  //     //  console.log(data);
  //   }
  //   fetchData();
  // }, []);

  // get random image to display in order table-:

  const randomIndex = Math.floor(Math.random() * allImages.length);

  // Get the random image URL
  const randomImageUrl = allImages[randomIndex];

  // const fetchData = async (url) => {
  //   try {
  //     const response = await axios.get(url);
  //     return response.data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const { data, error } = useSWR(`${baseURL}/order/admin/fetch-orders`, fetchData, {
  //   refreshInterval: 1000,
  // });
  // console.log(data, "data");
  // --------------------------------------Unpaid-------------------------------------------------//

  const [data, setdata] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/orders/getAllOrders?page=1&filter=unpaid`
        );

        const data = response?.data?.data?.orderDetails || [];

        setdata(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  //-----------------------------------------Proccessing---------------------------------//
  const [processing, setProcessing] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/orders/getAllOrders?page=1&filter=processing`
        );

        const data = response?.data?.data?.orderDetails || [];

        setProcessing(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // ----------------------------------------------SHIPPED-------------------------------------------------------//
  const [shipped, setShipped] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/orders/getAllOrders?page=1&filter=shipped`
        );

        const data = response?.data?.data?.orderDetails || [];

        setShipped(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // ----------------------------------------------Reviews-------------------------------------------------------//
  const [reviews, setReview] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/orders/getAllOrders?page=1&filter=review`
        );

        const data = response?.data?.data?.orderDetails || [];

        setReview(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // ------------------------------Tracking---------------------------//
   

  const [selectedTableRow, setSelectedRow] = useState(false);

  // render buttons for unpaid table component-:
  const RenderButtonCellUnpaid = ({ params }) => {
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const handleShowOrderDetails = () => {
      setShowOrderDetails(true);
    };
    const handleHideOrderDetails = () => {
      setShowOrderDetails(false);
    };

 return (
      <>
        <div className="" style={{ marginLeft: "-20px" }}>
          <Tooltip title="Show Details">
            <IconButton>
              <MdOutlinePreview
                onClick={(e) => {
                  handleShowOrderDetails(params.row.orderDetails.orderId);
                  console.log(params.row.orderDetails.orderId, "PPPPPPPPPPPPPP"), e.stopPropagation();
                }}
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          </Tooltip>

          <ModalComponent
            title={" Order Details"}
            open={showOrderDetails}
            handleClose={handleHideOrderDetails}
          >
            <OrderDetails orderId={params.row.id} />
          </ModalComponent>
        </div>
      </>
    );
  };
  const device = useMemo(
    () =>
      data &&
      data?.map((data, index) => ({
        ...data,
        id: data?._id,
      }))
  );

  const columns = [
    { field: "_id", headerName: "ID", width: 90, hideable: true },

    {
      field: "productName",
      headerName: "Product Name",
      width: "180",
    },

    {
      field: "productImage",
      headerName: "Image",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="flex" style={{ marginLeft: "-10%" }}>
            {Array.isArray(params.row.productImage) &&
              params.row.productImage.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  className="h-[7vh] w-[6vw] object-contain mr-2"
                  alt={`Product Image ${index + 1}`}
                />
              ))}
            {!Array.isArray(params.row.productImage) && (
              <img
                src={params.row.productImage}
                className="h-[7vh] w-[6vw] object-contain mr-2"
                alt="Product Image"
              />
            )}
          </div>
        );
      },
    },

    {
      field: "OrderDetails",
      headerName: "Order Details",
      width: 200,
      renderCell: (params) => {
        // Render order details here
        const orderDetails = params.row.orderDetails;
        if (orderDetails) {
          return `${orderDetails.orderId} - ${orderDetails.productName}`;
        } else {
          return "No details available";
        }
      },
    },

    {
      field: "storeId",
      headerName: "Sku Id store",
      width: 100,
    },
    {
      field: "userId",
      headerName: "User Id",
      width: 100,
    },
    {
      field: "yuan",
      headerName: "¥",
      width: 100,
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      width: 150,
      // editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      // editable: true,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      width: 100,
      // editable: true,
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 100,
      // editable: true,
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      width: 150,
      // editable: true,
    },

    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 100,
      renderCell: (params) => <RenderButtonCellUnpaid params={params} />,
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  const [updatedNewRow, setUpdatedRow] = useState(null);
  const initialRows = data?.unpaidWithId;
  // const initialRows = data?.categories.map((mydata) => ({
  //     ...mydata,
  //     image: { arrowimg },
  // }));
  // console.log(initialRows);

  const [rows, setRows] = useState(initialRows);
  const [rowModesModel, setRowModesModel] = useState({});
  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setUpdatedRow(updatedRow);
    console.log(newRow);
    await handleUpdateCategory(newRow.id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedNewRow;
  };

  const [allIds, setAllIds] = useState([]);

  const RenderButtonCellProcessing = (params) => {
    console.log(params,'3333')
    const [stoppedOrder, setStoppedOrder] = useState(params?.row?.stop);
    const handleStopOrder = (row) => {
      setStoppedOrder(true);
      axios.put(`${process.env.REACT_APP_BASE_URL}/shipping/stopAndStart?orderId=${row.orderDetails.orderId}`,
      {
        stop:true 
      })
    };
    const handleContinueOrder = (row) => {
      setStoppedOrder(false);
      axios.put(`${process.env.REACT_APP_BASE_URL}/shipping/stopAndStart?orderId=${row.orderDetails.orderId}`,
      {
        stop:false 
      })
    };
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
      setOpenModal(true);
    };
    const closeModal = () => {
      setOpenModal(false);
    };

    // continue order handler-:

    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const handleShowOrderDetails = () => {
      setShowOrderDetails(true);
    };
    const handleHideOrderDetails = () => {
      setShowOrderDetails(false);
    };
    const [orderLocationData, setOrderLocationData] = useState({});
    const [locationHistoryData, setLocationHistoryData] = useState([]);

    const fetchDataForMultiplePages = async (_id) => {
      try {
        // setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/shipping/getOrderLocation/${_id}`
        );

        const orderLocationData = response?.data?.orderLocation || {};
        const locationHistory = orderLocationData.locationHistory || [];

        setOrderLocationData(orderLocationData);
        setLocationHistoryData(locationHistory);
        // setUnpaid(locationHistory);
        // setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // setLoading(false);
      }
    };
    // continue order handler-:

    return (
      <>
        <div className="" style={{ marginLeft: "-20px" }}>
          <Tooltip title="Show Details">
            <IconButton>
              <MdOutlinePreview
                onClick={(e) => {
                  handleShowOrderDetails(params.row._id);
                  console.log(params, "PPPPPPPPPPPPPP"), e.stopPropagation();
                }}
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          </Tooltip>

          {stoppedOrder ? (
            <Tooltip title="Continue">
              <IconButton>
                <FaCirclePlay
                  onClick={(e) => {
                    handleContinueOrder(params.row);
                    e.stopPropagation();
                  }}
                  className="text-green-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Stop">
              <IconButton>
                <FaCircleStop
                  onClick={(e) => {
                    handleStopOrder(params.row);
                    e.stopPropagation();
                  }}
                  className="text-red-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          )}

          {/* </div> */}
          <Tooltip title="Track">
            <IconButton>
              <IoLocationOutline
                onClick={(e) => {
                  handleOpenModal();
                  e.stopPropagation();
                  fetchDataForMultiplePages(params.row._id);
                }}
                className="text-blue-400 cursor-pointer text-xl"
              />
            </IconButton>
          </Tooltip>

          <ModalComponent
            title={"Track Processing Orders"}
            open={openModal}
            handleClose={closeModal}
          >
           
            <OrderTrackingLocationUI locationHistoryData={locationHistoryData} orderLocationData={orderLocationData}/>
          </ModalComponent>
          <ModalComponent
            title={" Order Details"}
            open={showOrderDetails}
            handleClose={handleHideOrderDetails}
          >
            <OrderDetails orderId={params.row.id} />
          </ModalComponent>
        </div>
      </>
    );
  };

  const processingRow = useMemo(
    () =>
      processing &&
      processing?.map((data, index) => ({
        ...data,
        id: data?._id,
      }))
  );

  const processingTableColumns = [
    { field: "_id", headerName: "ID", width: 90, hideable: true },

    {
      field: "productName",
      headerName: "Product Name",
      width: "180",
    },

    {
      field: "productImage",
      headerName: "Image",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="flex" style={{ marginLeft: "-10%" }}>
            {Array.isArray(params.row.productImage) &&
              params.row.productImage.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  className="h-[7vh] w-[6vw] object-contain mr-2"
                  alt={`Product Image ${index + 1}`}
                />
              ))}
            {!Array.isArray(params.row.productImage) && (
              <img
                src={params.row.productImage}
                className="h-[7vh] w-[6vw] object-contain mr-2"
                alt="Product Image"
              />
            )}
          </div>
        );
      },
    },

    {
      field: "OrderDetails",
      headerName: "Order Details",
      width: 200,
      renderCell: (params) => {
        // Render order details here
        const orderDetails = params.row.orderDetails;
        if (orderDetails) {
          return `${orderDetails.orderId} - ${orderDetails.productName}`;
        } else {
          return "No details available";
        }
      },
    },

    // {
    //   field: "orderId",
    //   headerName:"Order Id",
    //   width:"100"
    // },

    {
      field: "storeId",
      headerName: "Sku Id store",
      width: 100,
    },
    {
      field: "userId",
      headerName: "User Id",
      width: 100,
    },
    {
      field: "yuan",
      headerName: "¥",
      width: 100,
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      width: 150,
      // editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      // editable: true,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      width: 100,
      // editable: true,
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 100,
      // editable: true,
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      width: 150,
      // editable: true,
    },

    {
      field: "action",
      headerName: "Order Details",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 100,
      // height: 300,
      renderCell: RenderButtonCellProcessing,
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];

  const processingRows = data?.processingWithId;

  const ProcessingTable = () => {
    return (
      <>
        <Box sx={{ height: 540, width: "100%", background: "white", marginTop: "2%" }}>
          <DataGrid
            rows={processingRow}
            columns={processingTableColumns}
            editMode="row"
            checkboxSelection={true}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            // onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            experimentalFeatures={{ newEditingApi: true }}
            // slots={{
            //   toolbar: EditToolbar,
            // }}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            getRowId={(row) => row?._id}
          />
        </Box>
      </>
    );
  };

  // shipping table-:

  //    this component is to render buttons in shipping table
  //  needed to create seperate due to the re-render issue of parent component

  const RenderButtonCell = (params) => {
    const [stoppedOrder, setStoppedOrder] = useState(null);
    const handleStopOrder = (row) => {
      setStoppedOrder(row);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
      setOpenModal(true);
    };
    const closeModal = () => {
      setOpenModal(false);
    };

    // show order details-:
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const handleShowOrderDetails = () => {
      setShowOrderDetails(true);
    };
    const handleHideOrderDetails = () => {
      setShowOrderDetails(false);
    };

    // continue order handler-:
    const handleContinueOrder = () => {
      setStoppedOrder(null);
    };

    const [userdata, setdata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [orderLocation, setOrderLocation] = useState({});

    const fetchDataForMultiplePages = async (_id) => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/shipping/getOrderLocation/${_id}`
        );
        console.log(_id, "bbbbbbbbbbbbbb");
        const orderLocationData = response?.data?.orderLocation || {};
        const locationHistory = orderLocationData.locationHistory || [];
        setOrderLocation(orderLocationData);

        setdata(locationHistory);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    return (
      <>
        <div className="flex items-center gap-2">
          <Tooltip title="Show Details">
            <IconButton>
              <MdOutlinePreview
                onClick={(e) => {
                  handleShowOrderDetails(params.row._id);
                  console.log(params, "PPPPPPPPPPPPPP"), e.stopPropagation();
                }}
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          </Tooltip>
          {stoppedOrder?.id === params.row.id ? (
            <Tooltip title="Continue">
              <IconButton>
                <FaCirclePlay
                  onClick={(e) => {
                    handleContinueOrder();
                    e.stopPropagation();
                  }}
                  className="text-green-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Stop">
              <IconButton>
                <FaCircleStop
                  onClick={(e) => {
                    handleStopOrder(params.row);
                    e.stopPropagation();
                  }}
                  className="text-red-400 text-xl"
                />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Track">
            <IconButton>
              <IoLocationOutline
                onClick={(e) => {
                  handleOpenModal();
                  e.stopPropagation();
                  fetchDataForMultiplePages(params.row._id);
                }}
                className="text-blue-400 cursor-pointer text-xl"
              />
            </IconButton>
          </Tooltip>
          {/* </div> */}

          {/* <ModalComponent title={"Track Shipped Orders"} open={openModal} handleClose={closeModal}>
            <section class="root">
              <div class="order-track">
                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Order Id</p>
                    <span class="order-track-text-sub"> {orderLocation.orderId}</span>
                  </div>
                </div>
                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Status</p>
                    <span class="order-track-text-sub">{orderLocation.status}</span>
                  </div>
                </div>
                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat"> Current Location</p>
                    <span class="order-track-text-sub">{orderLocation.location}</span>
                  </div>
                </div>
                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Days</p>
                    <span class="order-track-text-sub">{orderLocation.estimatedTime}</span>
                  </div>
                </div>
                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Location</p>

                    {userdata.map((historyItem, index) => (
                      <span class="order-track-text-sub"> {historyItem.location}</span>
                    ))}
                  </div>
                </div>

                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Delivery Status</p>

                    {userdata.map((historyItem, index) => (
                      <span class="order-track-text-sub"> {historyItem.location}</span>
                    ))}
                  </div>
                </div>

                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Time</p>

                    {userdata.map((historyItem, index) => (
                      <span class="order-track-text-sub"> {historyItem.time}</span>
                    ))}
                  </div>
                </div>

                <div class="order-track-step">
                  <div class="order-track-status">
                    <span class="order-track-status-dot"></span>
                    <span class="order-track-status-line"></span>
                  </div>
                  <div class="order-track-text">
                    <p class="order-track-text-stat">Mode</p>
                    <span class="order-track-text-sub">{orderLocation.mode}</span>
                  </div>
                </div>
              </div>
            </section>
          </ModalComponent> */}
          <ModalComponent
            title={" Order Details"}
            open={showOrderDetails}
            handleClose={handleHideOrderDetails}
          >
            <OrderDetails order={params.row} />
          </ModalComponent>

          <div></div>
        </div>
        {/* display model on clicking on track */}

        <ModalComponent
          title={" Order Details"}
          open={showOrderDetails}
          handleClose={handleHideOrderDetails}
        >
          <OrderDetails orderId={params.row.id} />
        </ModalComponent>
      </>
    );
  };

  const shippingRows = data?.shippedWithId;
  const Shiped = useMemo(
    () =>
      shipped &&
      shipped?.map((data, index) => ({
        ...data,
        id: data?._id,
      }))
  );
  const shippingColumns = [
    { field: "_id", headerName: "ID", width: 90, hideable: true },

    {
      field: "productName",
      headerName: "Product Name",
      width: "180",
    },

    {
      field: "productImage",
      headerName: "Image",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="flex" style={{ marginLeft: "-10%" }}>
            {Array.isArray(params.row.productImage) &&
              params.row.productImage.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  className="h-[7vh] w-[6vw] object-contain mr-2"
                  alt={`Product Image ${index + 1}`}
                />
              ))}
            {!Array.isArray(params.row.productImage) && (
              <img
                src={params.row.productImage}
                className="h-[7vh] w-[6vw] object-contain mr-2"
                alt="Product Image"
              />
            )}
          </div>
        );
      },
    },

    {
      field: "OrderDetails",
      headerName: "Order Details",
      width: 200,
      renderCell: (params) => {
        // Render order details here
        const orderDetails = params.row.orderDetails;
        if (orderDetails) {
          return `${orderDetails.orderId} - ${orderDetails.productName}`;
        } else {
          return "No details available";
        }
      },
    },

    {
      field: "storeId",
      headerName: "Sku Id store",
      width: 100,
    },
    {
      field: "userId",
      headerName: "User Id",
      width: 100,
    },
    {
      field: "yuan",
      headerName: "¥",
      width: 100,
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      width: 150,
      // editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      // editable: true,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      width: 100,
      // editable: true,
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 100,
      // editable: true,
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      width: 150,
      // editable: true,
    },
    {
      field: "action",
      headerName: "Order Details",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      disableClickEventBubbling: true,
      width: 150,
      // height: 300,
      renderCell: RenderButtonCellProcessing,
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];

  const ShippingTable = () => {
    return (
      <>
        <Box sx={{ height: 540, width: "100%", background: "white", marginTop: "2%" }}>
          <DataGrid
            rows={Shiped}
            columns={shippingColumns}
            editMode="row"
            checkboxSelection={true}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            experimentalFeatures={{ newEditingApi: true }}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            getRowId={(row) => row?._id}
          />
        </Box>
      </>
    );
  };

  //   review table component-:
  const Review = useMemo(
    () =>
      reviews &&
      reviews?.map((data, index) => ({
        ...data,
        id: data?._id,
      }))
  );

  const reviewColumns = [
    { field: "_id", headerName: "ID", width: 90, hideable: true },

    {
      field: "productName",
      headerName: "Product Name",
      width: "180",
    },

    {
      field: "productImage",
      headerName: "Image",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="flex" style={{ marginLeft: "-10%" }}>
            {Array.isArray(params.row.productImage) &&
              params.row.productImage.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  className="h-[7vh] w-[6vw] object-contain mr-2"
                  alt={`Product Image ${index + 1}`}
                />
              ))}
            {!Array.isArray(params.row.productImage) && (
              <img
                src={params.row.productImage}
                className="h-[7vh] w-[6vw] object-contain mr-2"
                alt="Product Image"
              />
            )}
          </div>
        );
      },
    },

    {
      field: "OrderDetails",
      headerName: "Order Details",
      width: 200,
      renderCell: (params) => {
        // Render order details here
        const orderDetails = params.row.orderDetails;
        if (orderDetails) {
          return `${orderDetails.orderId} - ${orderDetails.productName}`;
        } else {
          return "No details available";
        }
      },
    },

    // {
    //   field: "orderId",
    //   headerName: "Order Id",
    //   width: 100,
    // },

    {
      field: "storeId",
      headerName: "Sku Id store",
      width: 100,
    },
    {
      field: "userId",
      headerName: "User Id",
      width: 100,
    },
    {
      field: "yuan",
      headerName: "¥",
      width: 100,
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      width: 150,
      // editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 100,
      // editable: true,
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      width: 100,
      // editable: true,
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 100,
      // editable: true,
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      width: 150,
      // editable: true,
    },

    {
      field: "status",
      headerName: "Order Status",
      width: 200,
      // editable: true,
    },
    {
      field: "feedBack",
      headerName: "Feedback",
      width: 200,
      // editable: true,
      renderCell: (params) => {
        return (
          <>
            <div className="flex flex-col gap-2">
              <Rating name="read-only" value={5} readOnly />
              <span>Great Product</span>
            </div>
          </>
        );
      },
    },
  ];

  //  review table component-:

  const ReviewTable = () => {
    return (
      <>
        <Box sx={{ height: 540, width: "100%", background: "white", marginTop: "2%" }}>
          <DataGrid
            rows={Review}
            columns={reviewColumns}
            editMode="row"
            checkboxSelection={true}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            experimentalFeatures={{ newEditingApi: true }}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            getRowId={(row) => row?._id}
          />
        </Box>
      </>
    );
  };

  const [formLoading, setFormLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);

    try {
      setFormLoading(true);
      const res = await axios.post(`${baseURL}/admin/upload-category`, formData);
      console.log(res);
      if (res.status === 200) {
        setFormLoading(false);

        navigate("/");
      }
    } catch (error) {
      setFormLoading(false);

      console.log(error);
    }
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  async function handleUpdateCategory(id, obj) {
    try {
      setFormLoading(true);

      const res = await axios.post(
        `${baseURL}/admin/edit-category/${id}`,
        {
          ...obj,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        setFormLoading(false);
      }
      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
      console.log(error);
    }
  }

  const [enableSelection, setEnableSelection] = useState(false);

  const handleEnableSelection = () => {
    setEnableSelection(!enableSelection);
  };

  //   const onRowsSelectionHandler = (Ids) => {
  //     const selectedRowsData = ids.map((id) => initialRows.find((row) => row.Id === Id));
  //     const foundIds = selectedRowsData.map((d) => d.Id);
  //     setAllIds(foundIds);
  //   };

  const handleDeleteSelectedRows = async () => {
    try {
      setFormLoading(true);
      const res = await axios.post(`${baseURL}/admin/delete/categories`, {
        ids: allIds,
      });

      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
    }
  };

  const [tableType, setTableType] = useState("Unpaid");

  const handleSwitchTables = (type) => {
    console.log(type);
    setTableType(type);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!data && <LoaderComponent open={true} />}
      {/* {formLoading && <LoaderComponent open={true} />} */}

      {/*             
                {
                    allIds.length > 0 && <button onClick={handleDeleteSelectedRows} type="button" className="bg-green-700 h-[5vh] rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white">Delete Selected</button>
                } */}

      <div className="flex  gap-4" style={{ marginLeft: "70%" }}>
        <button
          style={{ background: tableType === "Unpaid" ? "purple" : "" }}
          onClick={() => handleSwitchTables("Unpaid")}
          className={`border-none cursor-pointer  font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
        >
          Unpaid
        </button>
        <button
          style={{ background: tableType === "Processing" ? "purple" : "" }}
          onClick={() => handleSwitchTables("Processing")}
          className={`border-none  cursor-pointer font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
        >
          Processing
        </button>
        <button
          style={{ background: tableType === "Shipped" ? "purple" : "" }}
          onClick={() => handleSwitchTables("Shipped")}
          className={`border-none cursor-pointer font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
        >
          Shipped
        </button>
        <button
          style={{ background: tableType === "Review" ? "purple" : "" }}
          onClick={() => handleSwitchTables("Review")}
          className={`border-none  cursor-pointer font-semibold text-white bg-slate-400  outline-none rounded-md p-3`}
        >
          Review
        </button>
      </div>
      <Box sx={{ height: 540, width: "100%", background: "white", marginTop: "2%" }}>
        {tableType === "Unpaid" ? (
          <DataGrid
            rows={device}
            columns={columns}
            editMode="row"
            checkboxSelection={true}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            // onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            experimentalFeatures={{ newEditingApi: true }}
            // slots={{
            //   toolbar: EditToolbar,
            // }}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            getRowId={(row) => row?._id}
          />
        ) : tableType === "Processing" ? (
          <ProcessingTable />
        ) : tableType === "Shipped" ? (
          <ShippingTable />
        ) : (
          <ReviewTable />
        )}
      </Box>

      <Footer />
    </DashboardLayout>
  );
}

export default OrderList;
